import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

/**
 * Temporary access control configuration during feature development.
 * To be removed once the feature is fully released.
 */
export const mfaEarlyAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.MultiFactorAuth],
}

export const mfaRetailerAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.EnableMfaManagementForRetailer],
}

export const viewRetailerSecurityAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ViewWarehouseSecurity],
  ...mfaEarlyAccessControl,
  ...mfaRetailerAccessControl,
}

export const modifyRetailerSecurityAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ManageWarehouseSecurity],
  ...mfaEarlyAccessControl,
  ...mfaRetailerAccessControl,
}

// A bit of a workaround used for launch only. Cannot target roulettes at a partner-level,
// so using user-level roulette to control display of modal (with some manual work done to enable for relevant account_ids)
export const mfaLaunchModalAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ManageWarehouseSecurity],
  featureToggles: [FeatureToggle.MfaModalDisplay],
}
